// src/utils/setRem.js
(function () {
  const MAX_WIDTH = 375; // 设计稿宽度上限（对应 rootValue 37.5）
  const baseDivisor = 10; // 和你的 pxtorem 约定一致

  function setRemBase() {
    const docEl = document.documentElement;
    let width = docEl.getBoundingClientRect().width;

    // 处理横屏：宽度大于375时，强制按375计算
    if (width > MAX_WIDTH) {
      width = MAX_WIDTH;
    }

    const rem = width / baseDivisor;
    docEl.style.fontSize = rem + 'px';
  }

  setRemBase();

  // 横竖屏切换和窗口大小变化时重算
  window.addEventListener('resize', () => {
    // iOS Safari 横竖屏切换存在抖动，延迟一点更稳
    setTimeout(setRemBase, 100);
  });
  window.addEventListener('orientationchange', () => {
    setTimeout(setRemBase, 100);
  });
  document.addEventListener('DOMContentLoaded', setRemBase);
})();